<epay-page-content [pagetitle]="pagetitle">

    <div class="container m--full-bleed mt-4">
      <div class="row m--full-bleed form-display-card">
        <mat-card tabindex="0" class="card-container">
          <mat-card-header class="pl-2">
            <mat-card-title>
              <h1 style="color: green;">SUCCESS</h1>
            </mat-card-title>
            <!-- <mat-card-title *ngIf="confirmation">
              <b>Confirmation Number: {{ confirmation }}</b>
            </mat-card-title> -->
          </mat-card-header>
          <mat-card-content>
            <p  class="p-2">
              Recurring Credit Card: Add Credit Card Successful
            </p>
  
            <!-- <p class="p-2">A confimation e-mail was sent to
              <span style="font-weight: 600;">{{confirmationEmailAddress}}</span>
            </p>
            <p class="p-2">
              Use this confirmation number for contacting customer service with any inquiries
              regarding this transaction. Please print this page for your records.
            </p> -->
  
            <div class="p-2 container-fluid">
              <p class="mb-5">Your card has been saved successfully.</p>
              <br>
              <p><i>For security reasons, your account was logged out during this process. Please login to view changes.</i></p>
              <br>
            </div>
  
            <div class="flex-btn-row p-2">
              <button class=" btn btn-primary" mat-button (click)="goHome()">Login</button>
  
              <!-- <button *ngIf="showEmailMismatch && employerUseEmailForLogin" mat-button class="btn btn-primary"
                (click)="goToChangeEmail()">Yes Change
                Username</button> -->
            </div>
            <div *ngIf="sender" class="mt-3 ml-2" style="font-size: larger; font-weight: 600;">
              <a></a>
              <!-- <a (click)="goBack()">
                <i class="fa fa-arrow-circle-o-left fa-md-blue"></i>
                Back To {{sender}}
              </a> -->
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  
  </epay-page-content>
  